import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { DownlineTreeviewItem, OrderDownlineTreeviewEventParser, TreeviewComponent, TreeviewEventParser, TreeviewHelper, TreeviewItem } from 'ngx-treeview';
@Component({
  selector: 'app-create-update-role',
  templateUrl: './create-update-role.component.html',
  styleUrls: ['./create-update-role.component.css'],
  providers: [
    { provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser },
  ]
})
export class CreateUpdateRoleComponent implements OnInit {

  // customerName:string="";
  // listeUser:any[]=[{
  //   nom:"YAO",
  //   prenom:"Kouassi",
  //   login:"yakou",
  //   contact:"09212109",
  //   statut:'COMMERCANT',
  //   createdAt:"10/10/2010"
  // }];
  // p:number=1
  @Input() roleToUpdate;
  onClose: Subject<boolean> = new Subject<boolean>();
  submitted = false;
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  roleFormGroup:FormGroup;
  spinnerLoading = false;
  roles = []
  agences = []
  connectedUser:any;
  @ViewChild(TreeviewComponent) treeviewComponent: TreeviewComponent;
  items: TreeviewItem[] = []
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500
 }
 functionnalities = [];
  constructor(public httpService:HttpService,private notification:NotificationService,public modalRef:BsModalRef,private formBuilder:FormBuilder) { 
    this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
  }

  ngOnInit() {
    this.onClose.next(false);
    this.getFunctionnalitiesWithChild()
    this.roleFormGroup = this.formBuilder.group({
      EnseigneProfilID: this.roleToUpdate ? this.roleToUpdate["ID"] : '',
      LibelleProfil: [this.roleToUpdate ? this.roleToUpdate["LibelleProfil"] : "", Validators.required],
      FonctionnalitesID: [[], [Validators.required,Validators.minLength(1)]],
      Description: this.roleToUpdate ? this.roleToUpdate["Description"] : ""
    })

}
checkPasswords(group: FormGroup) { // here we have the 'passwords' group
let pass = group.controls.Password.value;
let confirmPass = group.controls.ConfirmPassword.value;
return pass === confirmPass ? null : { notSame: true }
}

get EnseigneProfilID () {
  return this.roleFormGroup.get('EnseigneProfilID');
}
get LibelleProfil () {
  return this.roleFormGroup.get('LibelleProfil');
}
get FonctionnalitesID() {
  return this.roleFormGroup.get('FonctionnalitesID');
}
get Description() {
  return this.roleFormGroup.get('Description');
}
// get ConfirmPassword() {
//   return this.roleFormGroup.get('ConfirmPassword');
// }

getFunctionnalitiesWithChild() {
  let data = {}
  this.httpService.execute('enseigneUser/getAllEnseigneFonctionnaliteWithChilds', data).subscribe(res => {
    if (res.Data && res.Data.length) {
      this.functionnalities = res.Data
      this.items = res.Data.map(f => this.transformToTreeItem(f))
      let fonctionnaliteIDs: number[] = this.roleToUpdate ? this.roleToUpdate["Fonctionnalites"].map(fonctionnalite => fonctionnalite.ID) : [];
      if(fonctionnaliteIDs.length){
        fonctionnaliteIDs.forEach(id => {
          this.items.map(item => this.selectedFunctionnality(item,id))
        });
      }
    }
    else {
      this.functionnalities = [];
      this.items = []
    }
  },
    err => {
 
    })
}
transformToTreeItem(functionnality:any): TreeviewItem{
  return new TreeviewItem({
    text: functionnality.LibelleFonctionnalite,
    value: functionnality.ID,
    disabled: !functionnality.Statut,
    checked: false,
    children: functionnality.FonctionnaliteEnfants ? functionnality.FonctionnaliteEnfants.map(f => this.transformToTreeItem(f)) : []
  })
}


createOrUpdateRole(){
  this.submitted = true;
  this.spinnerLoading = true;
  
  if(this.roleFormGroup.valid){

    const data = {
      ...this.roleFormGroup.value,
    };
    this.httpService
    .execute(!this.EnseigneProfilID.value ? 'enseigneProfil/create': 'enseigneProfil/update', data)
    .subscribe(res => {
      //console.log('create abonne response', res);
      if (!res.HasError) {
        this.notification.smallBox({
          title: "Succès !",
          content: (!this.EnseigneProfilID.value ? "Création ": "Modification ")+"effectuée avec succès",
          color: "#35a646",
          timeout: 6000,
          icon: "fa fa-check"
      });
      this.onClose.next(true);
      this.modalRef.hide()
      } else {
        this.notification.smallBox({
        title: "Oops !",
        content: res.Message,
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
  }
    }, err => {
      this.notification.smallBox({
        title: "Oops !",
        content: err.Message,
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    });
  }
  this.spinnerLoading = false;
}
onSelectedChange(downlineItems: DownlineTreeviewItem[]): void {
  this.FonctionnalitesID.patchValue(this.setFunctionnalitiesID(downlineItems));
}
  setFunctionnalitiesID(downlineItems: DownlineTreeviewItem[]): any {
    let selectedRoles = []
    downlineItems.forEach(downlineItem => {
      const item = downlineItem.item;
      const value = item.value;
      let parent = downlineItem.parent;
      //console.log('item', item);
      //console.log('parent', parent);
      
      selectedRoles.push(value);
      while(parent){
        if(parent && !(selectedRoles.some(value => value === parent.item.value))){
          selectedRoles.push(parent.item.value);
        }
        parent = parent.parent;
      }
      //console.log("selected roles dans le foreach", selectedRoles);
    });
    //console.log("selected roles global", selectedRoles);
    return selectedRoles;
  }

/*removeItem(item: TreeviewItem): void {
  for (const tmpItem of this.items) {
    if (tmpItem === item) {
      this.items.filter(i => i.value != item.value)
    } else {
      if (TreeviewHelper.removeItem(tmpItem, item)) {
        break;
      }
    }
  }

  this.treeviewComponent.raiseSelectedChange();
}*/

onFilterChange(event){
  //console.log(event);
}

selectedFunctionnality(item: TreeviewItem, id: number): any {
  
  if(item.value === id){
    item.checked = true;
  }
  if(item.children && item.children.length){
    item.children.map(child => this.selectedFunctionnality(child,id))
  }
  return item;

}

}


